import { TabStyles } from './TabStyles';

export const PopupStyle: React.CSSProperties = {
  background: 'white',
  border: `1px solid ${TabStyles.Colors.L6}`,
  boxShadow: TabStyles.Shadow.Elevated,
  boxSizing: 'border-box',
  lineHeight: 'normal',
};
